const PARTS = new Intl.DateTimeFormat('ca', {
  timeZone: 'Europe/Madrid',
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/**
 * When the roadmap last changed, as a person says it in Catalan and in
 * Madrid's clock: «dimecres 14 d’octubre a les 00:06». Null for a date that
 * is not one. The ICU data lives in the browser, so the words are asked of
 * `Intl` and only the glue («a les», «a la» for the one o'clock hour) is ours.
 */
export function roadmapUpdatedAt(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return null;
  const part = Object.fromEntries(PARTS.formatToParts(at).map((p) => [p.type, p.value]));
  const month = part.month ?? '';
  // CLDR's long month in a date with a day already carries its «de»/«d’»; older ICU data may not.
  const of = /^(de |d[’'])/i.test(month) ? '' : /^[aeiouàèéíòóú]/i.test(month) ? 'd’' : 'de ';
  const hour = part.hour ?? '00';
  const article = Number(hour) === 1 ? 'a la' : 'a les';
  return `${part.weekday} ${part.day} ${of}${month} ${article} ${hour}:${part.minute}`;
}
